import { render, staticRenderFns } from "./salesprice-edit-dialog.vue?vue&type=template&id=108c6579&scoped=true&"
import script from "./salesprice-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./salesprice-edit-dialog.vue?vue&type=script&lang=js&"
import style0 from "./salesprice-edit-dialog.vue?vue&type=style&index=0&id=108c6579&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c6579",
  null
  
)

export default component.exports